import { render, staticRenderFns } from "./JustWait.vue?vue&type=template&id=e0702412"
import script from "./JustWait.vue?vue&type=script&lang=js"
export * from "./JustWait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports